import { render, staticRenderFns } from "./RolPermissionModal.vue?vue&type=template&id=5dc646c2&scoped=true&"
import script from "./RolPermissionModal.vue?vue&type=script&lang=js&"
export * from "./RolPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./RolPermissionModal.vue?vue&type=style&index=0&id=5dc646c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc646c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc646c2')) {
      api.createRecord('5dc646c2', component.options)
    } else {
      api.reload('5dc646c2', component.options)
    }
    module.hot.accept("./RolPermissionModal.vue?vue&type=template&id=5dc646c2&scoped=true&", function () {
      api.rerender('5dc646c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/roles/RolPermissionModal.vue"
export default component.exports